import { useCallback } from 'react'
import { invalidateCachedFetch, useAuth } from '@structural-climbing/auth'

/**
 * Self check-out, for the member or one of their children.
 *
 * Home and Contul meu › Familie both check children out, so the call lives
 * here once. `refresh` re-reads the check-in status afterwards.
 */
export function useCheckOut(gymId: string | null, refresh: () => Promise<void>) {
  const { getAccessTokenSilently } = useAuth()
  const apiUrl = import.meta.env.VITE_API_URL as string

  const post = useCallback(
    async (childId?: string) => {
      if (!gymId) return
      const token = await getAccessTokenSilently()
      const query = new URLSearchParams({ gym_id: gymId })
      if (childId) query.set('child_id', childId)
      const res = await fetch(`${apiUrl}/my-check-out?${query.toString()}`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
      })
      if (!res.ok) throw new Error('checkout failed')
      invalidateCachedFetch('gym-occupancy:')
      await refresh()
    },
    [apiUrl, gymId, getAccessTokenSilently, refresh],
  )

  const checkOut = useCallback(() => post(), [post])
  const checkOutChild = useCallback((childId: string) => post(childId), [post])
  return { checkOut, checkOutChild }
}
